import PageTransitions from './PageTransitions'

import expand from './expand'
import windowLoad from '../events/window-load'
// import animate from './Animate'
// import taglines from './taglines'
import VisibleVideos from '../video/visible-videos'
const visibleVideos = new VisibleVideos()

import video from '../video'
import scrolling from './scrolling'
import carousels from './carousels'
import { Preloader, PreloaderIntroView } from '../preloader'
import lblblocks from '../lbl-blocks'
import work from '../work'
import imageComparisons from '../image-comparison'
import analytics from '../analytics'

import Cookies from 'universal-cookie';
const cookies = new Cookies();

// Track the current scroll position
// var precentageScrolled = 0

// Track the current intro background image
// var introBackgroundImage = null

// Track whether filters need to be updated in the intro app
// var updateIntroFilters = false

// Get the best property to use for scroll position
// const scrollTopProperty = typeof window.scrollY === "undefined" ? 'pageYOffset' : 'scrollY'

const findCaseStudyNextPrev = (caseStudyIndex) => {
  let prevCaseStudy = null;
  let nextCaseStudy = null;

  let gridSort = cookies.get('work-grid-sort')
  if (typeof gridSort === 'undefined') {
    gridSort = Object.keys(caseStudies)
  }

  let gridSortLength = gridSort.length;
  let currentGridIndex = gridSort.indexOf(caseStudyIndex);
  let prevGridIndex = currentGridIndex - 1;
  let nextGridIndex = currentGridIndex + 1;

  if (prevGridIndex < 0) {
    prevGridIndex = gridSortLength - 1;
  }

  if (nextGridIndex > gridSortLength - 1) {
    nextGridIndex = 0;
  }

  prevCaseStudy = caseStudies[gridSort[prevGridIndex]];
  nextCaseStudy = caseStudies[gridSort[nextGridIndex]];

  return {
    previous: prevCaseStudy,
    next: nextCaseStudy,
  }
}

const applyLoadedResourceToDOM = (resource) => {

  let asset = document.getElementById(resource.name)
  let preloadedAsset = resource.data

  if (preloadedAsset.querySelector('source')) {
    let srcElement = preloadedAsset.querySelector('source')
    asset.setAttribute('src', srcElement.getAttribute('src'));
    asset.setAttribute('type', srcElement.getAttribute('type'));
  }

  if (asset.nodeName == 'VIDEO') {
    if (preloadedAsset.id == 'video-intro') {
      asset.play()
    }
  }
}

const getAssetsToPreload = (container) => {
  container = container || document
  const preloadBlocks = Array.from(container.querySelectorAll('[data-preload]:not(.content-block--intro)'))
  if (preloadBlocks.length == 0) {
    return {}
  }

  return Object.assign.apply({}, preloadBlocks.map((block) => JSON.parse(block.dataset.preload)))
}

const loadIntroAsset = () => {

  const introBlock =  document.querySelector('.content-block--intro')

  if (typeof introBlock.dataset.preload !== 'undefined') {
    const introAssets = JSON.parse(introBlock.dataset.preload)
    console.log(introAssets)
    const introPreloader = new Preloader(introAssets)
    return introPreloader.load()
  }

  return new Promise((resolve, reject) => {
    let unveilHandler = () => {
      // Allow time or the image to be placed/faded in
      setTimeout(() => {
        if (introBlock.classList.contains('content-video-block')) {
          introBlock.classList.add('video-autoplay');
          document.getElementById('video-intro').play();
        }

        resolve();
      })
      document.removeEventListener('lazybeforeunveil', unveilHandler)
    }

    document.addEventListener('lazybeforeunveil', unveilHandler)
  })
}

const loadDetail = (container) => {

  container = container || document

  const contentPreloader = new Preloader(getAssetsToPreload(container))
  const introPreloaderView = new PreloaderIntroView()
  const caseStudyIndex = document.querySelector('.work-detail').dataset.casestudyIndex

  const nextPrevCaseStudy = findCaseStudyNextPrev(caseStudyIndex)

  return new Promise((resolve, reject) => {

    let loadPromises = [loadIntroAsset()]
    let usePreloader = false
    if (document.readyState == 'complete') {
      usePreloader = true
      loadPromises.push(introPreloaderView.start({ skipLogoAnimation: true, }))
    }

    Promise.all(loadPromises).then((results) => {

      // Reset the scroll position once the intro image is in place
      window.scrollTo(0, 0)

      if (nextPrevCaseStudy.next && nextPrevCaseStudy.previous) {
        let nextPrevContainer = document.getElementById('casestudy-next-prev')
        let prevCaseStudyLink = document.getElementById('prev-casestudy')
        let nextCaseStudyLink = document.getElementById('next-casestudy')

        nextPrevContainer.classList.remove('u-display-none')

        prevCaseStudyLink.setAttribute('href', nextPrevCaseStudy.previous.url)
        prevCaseStudyLink.setAttribute('title', nextPrevCaseStudy.previous.title)

        nextCaseStudyLink.setAttribute('href', nextPrevCaseStudy.next.url)
        nextCaseStudyLink.setAttribute('title', nextPrevCaseStudy.next.title)
      }

      // Only need to finish the preloader if it was started initially
      if (usePreloader) {
        // Finish the preloader. Don't return here so the
        // promise can kick off other things while things are still loading.
        introPreloaderView.finish().then(() => {
          scrolling.init()
          carousels.init();
          visibleVideos.addVideos('video:not(.intro-video)')
          video.init();
        })
      }

      let assets = getAssetsToPreload(container)
      Object.keys(getAssetsToPreload(container)).forEach((assetKey) => {
        document.getElementById(assetKey).setAttribute('src', assets[assetKey])
      })

      if (!usePreloader) {
        scrolling.init()
        carousels.init();
        visibleVideos.addVideos('video:not(.intro-video)')
        video.init();
      }
    }).then(() => {
      resolve();
    })
    .catch((e) => {
      console.warn(e)
    })
  })
}

const introPreloaderView = new PreloaderIntroView()
window.introPreloaderView = introPreloaderView

let windowInnerWidth = window.innerWidth
function fixContentSizing(e) {

  if (typeof e !== 'undefined') {
    // Prevent running this function unless it's called directly
    // Or there's actual resize. Deals with the height changes in iOS on scroll
    if (window.innerWidth == windowInnerWidth) {
      return;
    }
  }

  windowInnerWidth = window.innerWidth
  let blockSizing = document.querySelectorAll('.work-detail .content-block')

  blockSizing.forEach((block) => {
    block.style.height = 'auto';
  })

  setTimeout(() => {
    blockSizing.forEach((block) => {

      if (block.classList.contains('content-copy-block') || block.classList.contains('auto-height')) {
        return;
      }

      const blockRect = block.getBoundingClientRect()

      const ratio = 1080 / 1920
      const height = Math.floor(Math.floor(blockRect.width) * ratio)

      block.style.height = `${height}px`
    })
  })
}

window.addEventListener('resize', fixContentSizing)

const reset = () => {

  let isProjectDetail = document.querySelector('.work-detail')

  windowLoad()
    .then((res) => {

      analytics.init(isProjectDetail ? Array.from(isProjectDetail.querySelectorAll('.content-block')) : [])

      if (!res.init) {
        analytics.trackVirtualPageview({ eventCategory: location.pathname });
      }

      setTimeout(function() {
        toggleMomentsThatMove(false)
      }, 4000);

      let homepageVideo = document.getElementById('homepage-header-video')
      if (homepageVideo) {
        var loops = 0
        homepageVideo.addEventListener('ended', function() {
          if (loops > 0) {
            toggleMomentsThatMove(false)
          }

          setTimeout(function() {
            toggleMomentsThatMove(true)
          })

          // Need to loop the video
          homepageVideo.play();
          loops++;
        })
      }

      lblblocks.init()

      if (isProjectDetail) {
        fixContentSizing();
        expand.init()
        imageComparisons.init()
      }

      // For project detail, videos are already initialized after
      // the assets are preloaded
      if (!isProjectDetail) {
        work.init()
        carousels.init()
        scrolling.init()
        startReadyAnimations()
        video.init()
      }
    })
    .catch((e) => {
      console.warn(e)
    })
}

// Handle the initial page load
if (document.querySelector('.work-detail')) {
  loadDetail(document).then(() => {
    reset();
  })
} else {
  reset();
}

const startReadyAnimations = (delay) => {
  delay = typeof delay === 'undefined' ? 600 : delay;
  setTimeout(() => {
    Array.from(document.querySelectorAll('.js-has-animation')).forEach((element) => {
      element.classList.add('js-animation-ready')
    })
  }, delay);
}

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

const defaultTransition = ($container, $newScene) => {
  return new Promise((resolve, reject) => {

    const newHref = pageTransitions.smoothState.href
    const urlNoProtocol = newHref.replace(/https?:\/\//, '')
    const urlPath = urlNoProtocol.substring(urlNoProtocol.indexOf('/')) // Get everything after the first slash in the url

    const currentPage = $container.find('.page').get(0)
    const newPage = $newScene.filter('.page').get(0)
    newPage.classList.add('new-page')

    document.body.className = typeof newPage.dataset.bodyClasses === 'undefined' ? '' : newPage.dataset.bodyClasses;

    if (currentPage.nextSibling) {
      // Add the new page to the dom
      currentPage.parentNode.insertBefore(newPage, currentPage.nextSibling);
    } else {
      currentPage.parentNode.appendChild(newPage);
    }

    currentPage.parentNode.removeChild(currentPage);
    newPage.classList.remove('new-page')

    const fullPageTransition = newPage.classList.contains('transition--full')

    // Going to detail page
    if (newPage.dataset.pageType == 'casestudy') {//urlPath.match(/work\/(.+)/)
      loadDetail(newPage)
        .then(() => {
          resolve()
        })
    } else {
      introPreloaderView
        .start({ skipLogoAnimation: true, fullPageTransition, })
        .then(() => {
          window.scrollTo(0, 0)
          startReadyAnimations();
          return introPreloaderView.finish()
        })
        .then(() => {
          resolve()
        })
    }
  })
}

// var svg = Array.from(document.querySelectorAll('.marker-position'));
// var styleTags = svg.map((svg) => svg.querySelector('style'));
// styleTags.forEach((styleTag, i) => {
//   styleTag.textContent += '';
// });

const startDuration = 1000
const pageTransitions = PageTransitions.init({
  $wrapper: $('#m-wrapper'),
  transitions: {
    'default': defaultTransition
  },
  onStart: ($container, params) => {
    // Hide the nav if it's available
    window.nav.hide()
    introPreloaderView.show()
  },
  onComplete: reset,
  options: {
    onStartDuration: startDuration,
    // debug: APP_CONFIG.debug,
    cacheLength: 1,
    allowFormCaching: false,
    blacklist: '.no-pjax',
    prefetch: false,
    scroll: false,
  }
});
